import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from './utils/firebase';

export default function PrivateRoute({component: Component, ...rest}) {

    const { user } = useAuth()

    return(
        <Route
        {...rest}
        render={ props => 
            user ? (
                <Component {...props} {...rest} />
            ) : (
                <Redirect to="/" /> 
            )
        }
        />
    )
}